// extracted by mini-css-extract-plugin
module.exports = {"container":"similar-card-module--container--Z0z0y","text":"similar-card-module--text--2_n6w","card":"similar-card-module--card--2XMm2","img":"similar-card-module--img--vQp3V"};